import React from "react";
import { useSelector } from "react-redux";
import PostCard from "../../../../components/PostCard";
import './index.css'
import { sortByRecentDate } from "../../../../utils/sortArray";

const ListVisoriasPost = ()=>{
    const allPost = useSelector(state => state?.visorias?.allPost);
        const sortedRecentPost = sortByRecentDate(allPost) || []
    

    return(
                    <div className="list-visorias-post-container">
                        <div className="list-visorias-post-subcontainer">
                            {
                                sortedRecentPost?.map((visoriaPost )=>{
                                    return(
                                        <PostCard post={visoriaPost} />

                                    )
                                })
                            }
        
                        </div>
        
                    </div>

    )
}

export default ListVisoriasPost